<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="24" class="item">
              <el-card class="box-card" shadow='never'>
                <div slot="header" class="clearfix">
                  <span>{{schedulName1}}</span>
                </div>

                <el-col :span="24" class="item">
                  <el-form-item label="用药组">
                    <el-select
                        v-model="addForm.groupCodeArr1"
                        multiple style="width:100%"
                        filterable placeholder="请选择用药组">
                      <el-option
                          v-for="item in listGroup"
                          :key="item.medicationGroupCode"
                          :label="item.name"
                          :value="item.medicationGroupCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-card>
            </el-col>
          </el-row>

          <el-row style="margin-top: 10px;">
            <el-col :span="24" class="item">
              <el-card class="box-card" shadow='never'>
                <div slot="header" class="clearfix">
                  <span>{{schedulName2}}</span>
                </div>
                <el-col :span="24" class="item">
                  <el-form-item label="用药组">
                    <el-select
                        v-model="addForm.groupCodeArr2"
                        multiple style="width:100%"
                        filterable placeholder="请选择用药组">
                      <el-option
                          v-for="item in listGroup"
                          :key="item.medicationGroupCode"
                          :label="item.name"
                          :value="item.medicationGroupCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-card>
            </el-col>
          </el-row>

          <el-row style="margin-top: 10px;">
            <el-col :span="24" class="item">
              <el-card class="box-card" shadow='never'>
                <div slot="header" class="clearfix">
                  <span>{{schedulName3}}</span>
                </div>
                <el-col :span="24" class="item">
                  <el-form-item label="用药组">
                    <el-select
                        v-model="addForm.groupCodeArr3"
                        multiple style="width:100%"
                        filterable placeholder="请选择用药组">
                      <el-option
                          v-for="item in listGroup"
                          :key="item.medicationGroupCode"
                          :label="item.name"
                          :value="item.medicationGroupCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-card>
            </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  props:['nurseList','nurseAideList'],
  data() {
    return {
      loading: false,

      schedulName1:'早晨用药',
      schedulName2:'中午用药',
      schedulName3:'晚上用药',


      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        timeArr:[],
        elderlyCode:'',

        groupCodeArr1:[],
        groupCodeArr2:[],
        groupCodeArr3:[],

        schedulingPlan:[],
      },

      listGroup:[],

      rules:{
        groupCodeArr1:[{ required: true, message: '请选择用药组', trigger: 'blur' }],
        groupCodeArr2:[{ required: true, message: '请选择用药组', trigger: 'blur' }],
        groupCodeArr3:[{ required: true, message: '请选择用药组', trigger: 'blur' }],
      }

    }
  },

  methods: {
    init(dateList,elderlyCode){
      this.$refs.addForm.resetFields();
      this.addForm.timeArr=dateList;
      this.addForm.elderlyCode = elderlyCode;

      this.getGroupList();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    getGroupList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationGroup/ListByElderly2",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode:this.addForm.elderlyCode,
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          this.listGroup = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },
    addSubmit(){

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.addForm.schedulingPlan = [];
      this.addForm.schedulingPlan.push({groupCodeArr:this.addForm.groupCodeArr1})
      this.addForm.schedulingPlan.push({groupCodeArr:this.addForm.groupCodeArr2})
      this.addForm.schedulingPlan.push({groupCodeArr:this.addForm.groupCodeArr3})

      let c = this.addForm.groupCodeArr1.length+this.addForm.groupCodeArr2.length+this.addForm.groupCodeArr3.length;
      if(c == 0){
        this.$message.info("请至少选择一个用药组");
        return;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationScheduling/AddMany2",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>

</style>
